// extracted by mini-css-extract-plugin
export default {"thumbnailStyle":"BaseMapSwitcher-module__thumbnailStyle__IbPF3","swatchLabel":"BaseMapSwitcher-module__swatchLabel__foUqL"};